<template>
  <div>
    <v-row>
      <v-col md="12">
        <v-stepper v-model="step" @reload="reloadstep($event)" non-linear>
          <v-stepper-header>
            <v-stepper-step
              :complete="step > 1"
              step="1"
              :color="`${buttonColor}`"
              >{{ $t("riders.createRiders.title_step_1") }}</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step
              :complete="step > 1.1"
              step="1.1"
              :color="`${buttonColor}`"
              >{{ $t("riders.createRiders.title_step_1_2") }}</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step
              v-if="bandStep1_2"
              :complete="step > 1.2"
              step="1.2"
              :color="`${buttonColor}`"
              >{{
                $t("spectators.createSpectators.title_step_1_1")
              }}</v-stepper-step
            >
            <v-divider v-if="bandStep1_2"></v-divider>
            <v-stepper-step
              :complete="step > 2"
              step="2"
              :color="`${buttonColor}`"
              >{{ $t("riders.createRiders.title_step_2") }}</v-stepper-step
            >
          </v-stepper-header>

          <v-stepper-items class="st_items">
            <v-stepper-content step="1" style="padding: 0 0 12px 0">
              <v-container>
                <v-row>
                  <v-col md="12" cols="12">
                    <p class="mb-0 text-center">
                      {{ $t("spectators.createSpectators.content_step_1") }}
                    </p>
                  </v-col>
                  <v-col md="12" cols="12" class="text-center">
                    <h2>
                      {{ $t("spectators.createSpectators.subtitle_step_1") }}
                    </h2>
                  </v-col>
                  <v-col class="text-center">
                    <v-row>
                      <v-col md="6" cols="12" class="text-md-right">
                        <v-btn
                          @click="yesCreated"
                          :color="`${buttonColor}`"
                          class="btn_bg mx-auto ml-md-auto mr-md-0 my-0 my-md-6"
                        >
                          {{ $t("spectators.createSpectators.button_yes_create_account") }}
                        </v-btn>
                      </v-col>
                      <v-col md="6" cols="12" class="text-md-left">
                        <v-btn
                          @click="noCreated"
                          :color="`${buttonColor}`"
                          class="btn_bg my-0 my-md-6 mx-auto ml-md-0"
                        >
                          {{ $t("spectators.createSpectators.button_no_create_account") }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
              <v-row>
                <v-col md="12" cols="12">
                  <v-btn dark :color="`${buttonColor}`" class="ma-4" @click="goBack">{{ $t("common.back")}}</v-btn>
                </v-col>
              </v-row>
            </v-stepper-content>
            <v-stepper-content step="1.1">
              <v-container>
                <v-row>
                  <v-col>
                    <Register
                      ref="spectatorRegister"
                      @nextStep="yesCreated"
                      @previusStep="previusStep"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="1.2" v-if="bandStep1_2">
              <v-container>
                <v-row>
                  <v-col md="12" cols="12">
                    <p>
                      {{ $t("spectators.createSpectators.content_step_1_1") }}
                    </p>
                  </v-col>
                </v-row>
                <v-form
                  ref="formEmail"
                  class="mt-sm-0 mt-4"
                  @submit.prevent="searchByEmail"
                >
                  <v-row>
                    <v-col md="3" sm="4" cols="12" class="pt-0 pb-0 lbl_search">
                      <label class="lbl_search">
                        <v-icon>fa fa-search</v-icon>
                        {{ $t("riders.createRiders.find_by_email") }}
                      </label>
                      <v-text-field
                        v-model="email"
                        :rules="rules.email"
                        dense
                        outlined
                      >
                      </v-text-field>
                    </v-col>
                    <v-col md="3" sm="4" cols="12">
                      <v-btn
                        class="mt-sm-4 mt-0 btn_xs_rsp"
                        type="submit"
                        :loading="loadingEmail"
                      >
                        {{ $t("riders.createRiders.search_by_email") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
                <v-form
                  ref="formLLId"
                  class="mt-sm-0 mt-4"
                  @submit.prevent="searchByLLId"
                >
                  <v-row>
                    <v-col md="3" sm="4" cols="12" class="pt-0 pb-0 lbl_search">
                      <label class="lbl_search">
                        <v-icon>fa fa-search</v-icon>
                        {{ $t("riders.createRiders.find_by_ll_id") }}
                      </label>
                      <v-text-field
                        v-model="LLId"
                        :rules="rules.LLId"
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col md="3" sm="4" cols="12">
                      <v-btn
                        class="mt-sm-4 mt-0 btn_xs_rsp"
                        type="submit"
                        :loading="loadingId"
                      >
                        {{ $t("riders.createRiders.search_by_ll_id") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
                <v-row no-gutters class="mt-sm-0 mt-6">
                  <v-col md="12" cols="12">
                    <h4>
                      {{
                        $t("spectators.createSpectators.search_results_table")
                      }}
                    </h4>
                  </v-col>
                  <v-col md="12" cols="12" class="mb-1">
                    <!-- Table ... -->
                    <v-data-table
                      :headers="headers"
                      :items="items"
                      @click:row="selectRow"
                      item-key="id"
                      class="elevation-2 ma-0 dt_rider"
                      dense
                      :footer-props="{
                        'items-per-page-text': $t('dataTable.rowsPerPageText'),
                        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                      }"
                      :no-data-text="$t('dataTable.noDataText')"
                      :headerProps="{
                        'sort-by-text': $t('dataTable.sortByText')
                      }"
                    >
                      <template v-slot:[`item.selected`]="{ item }">
                        <v-simple-checkbox v-model="item.selected" :ripple="false" @click="selectRow(item)"></v-simple-checkbox>
                      </template>
                    </v-data-table>
                  </v-col>
                  <v-col v-if="spectatorSelected" class="text-left my-6 mt-md-1">
                    <!-- card selected -->
                    <h4>
                      {{
                        selected.length == 1
                          ? $t(
                              "spectators.createSpectators.selected_spectator"
                            )
                          : $t(
                              "spectators.createSpectators.selected_spectators"
                            )
                      }}
                    </h4>
                    <v-card max-width="344" outlined>
                      <v-list-item
                        v-for="(item, index) in selected"
                        :key="index"
                        two-line
                      >
                        <v-list-item-avatar
                          tile
                          size="80"
                          color="grey"
                          class="mb-2 mt-2"
                        >
                          <v-img
                            height="100%"
                            width="100%"
                            :src="item.image"
                            v-on:error="ImgError"
                          ></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content v-if="item">
                          <v-list-item-title>
                            {{ item.firstName }} {{ item.lastName }}
                          </v-list-item-title>
                          <v-list-item-title
                            >{{
                              $t("riders.createRiders.table_header_ll_id")
                            }}: {{ item.id }}
                            <div
                              style="position: absolute; right: 5px; top: 5px;"
                            >
                              <v-btn
                                depressed
                                color="error"
                                @click="selectRow(item,'remove')"
                              >
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </div>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col md="6" class="text-left">
                    <v-btn
                      @click="noCreated"
                      :color="`${buttonColor}`"
                      class="btn_back btn_bg"
                      >{{ $t("riders.createRiders.back_button") }}</v-btn
                    >
                  </v-col>
                  <v-col md="6" v-if="selected.length > 0" class="text-right">
                    <v-btn
                      @click="yesCreated"
                      :color="`${buttonColor}`"
                      class="btn_back btn_bg ml-auto"
                      >{{ $t("riders.createRiders.next") }}</v-btn
                    >
                  </v-col>
                </v-row>
              </v-container>
            </v-stepper-content>
            <v-stepper-content step="2">
              <v-container>
                <v-form ref="formAddSpectator" @submit.prevent="addSpectator">
                  <v-row>
                    <v-col md="12">
                      <p>
                        {{ $t("spectators.createSpectators.content_step_2") }}
                      </p>
                    </v-col>
                  </v-row>
                  <div v-for="(item, index) in selected" :key="index">
                    <v-row>
                      <v-col md="6" class="text-left">
                        <v-card max-width="344" outlined>
                          <v-list-item two-line>
                            <v-list-item-avatar
                              tile
                              size="80"
                              color="grey"
                              class="mb-2 mt-2"
                            >
                              <v-img
                                height="100%"
                                width="100%"
                                :src="item.image"
                                v-on:error="ImgError"
                              ></v-img>
                            </v-list-item-avatar>
                            <v-list-item-content v-if="item">
                              <v-list-item-title
                                >{{ item.firstName }}
                                {{ item.lastName }}</v-list-item-title
                              >
                              <v-list-item-title
                                >{{
                                  $t("riders.createRiders.table_header_ll_id")
                                }}: {{ item.id }}</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="6" v-if="item">
                        <p>
                          {{
                            $t("riders.whois") +
                              item.firstName +
                              " " +
                              item.lastName +
                              " (" +
                              item.id +
                              ") " +
                              $t("riders.whoisto") +
                              " " +
                              user.firstName +
                              " " +
                              user.lastName
                          }}?
                        </p>
                        <v-select
                          dense
                          outlined
                          v-model="select1[item.id]"
                          :rules="rules.select"
                          :label="$t('riders.relationship')"
                          :items="itemsRelationshipOptions"
                          item-text="text"
                          item-value="id"
                          :no-data-text="$t('common.no_data')"
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                  </div>
                  <v-row>
                    <v-col md="6" class="text-left">
                      <v-btn
                        @click="noCreated"
                        :color="`${buttonColor}`"
                        class="btn_back btn_bg"
                        >{{ $t("riders.createRiders.back_button") }}</v-btn
                      >
                    </v-col>
                    <v-col md="6" v-if="selected.length > 0" class="text-right">
                      <v-btn
                        type="submit"
                        :color="`${buttonColor}`"
                        class="btn_back btn_bg ml-auto"
                        >{{
                          $t("spectators.createSpectators.button_add_spectators")
                        }}</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
    <Snack
      :snack="snackbar"
      :snackMsg="msg_snackbar"
      :snackCol="color_snackbar"
    />
  </div>
</template>

<script>
import RelationshipService from "@/services/RelationshipService";
import AuthService from "@/services/AuthService";
import LocalStorageService from "@/services/LocalStorageService";
import {
  VRow,
  VCol,
  VStepperItems,
  VForm,
  VSelect,
  VStepper,
  VStepperContent,
  VContainer,
  VBtn,
  VDataTable,
  VTextField,
  VIcon,
  VStepperStep,
  VDivider,
  VStepperHeader,
  VListItemTitle,
  VListItemContent,
  VListItem,
  VImg,
  VListItemAvatar,
  VCard,
  VSimpleCheckbox
} from "vuetify/lib";
import Register from "@/components/Riders/Register.vue";
import { mapState } from "vuex";
import Snack from "@/components/notifications/Snack";

export default {
  name: "RidersCreate",
  components: {
    VRow,
    VCol,
    VStepperItems,
    VForm,
    VSelect,
    VTextField,
    VIcon,
    VStepper,
    VStepperContent,
    VContainer,
    VBtn,
    VDataTable,
    VStepperStep,
    VDivider,
    VStepperHeader,
    VListItemTitle,
    VListItemContent,
    VListItem,
    VImg,
    VListItemAvatar,
    VCard,
    Register,
    Snack,
    VSimpleCheckbox
  },
  data() {
    const createForm = Object.freeze({
      firstName: "",
      lastName: "",
      relationship: "",
      type: "",
    });
    return {
      step: 1,
      createForm,
      form: Object.assign({}, createForm),
      dynamicMenuItems: [],
      selected: [],
      items: [],
      singleSelect: false,
      select1: [],
      itemsRelationship: [],
      buttonColor: "#000",
      email: null,
      LLId: null,
      spectatorSelected: false,
      imageUrl: null,
      failed_image: true,
      user: null,
      LIVELAPS_HOST: null,
      userRoleId: 0,
      localData: {},
      bandCreateAccount: false,
      snackbar: false,
      msg_snackbar: "",
      color_snackbar: "",
      loadingEmail: false,
      loadingId: false,
      type: 'find',
      rules: {
        email: [
          val => (val || "").length > 0 || this.$t('profile.error_empty')
        ]
      }
    };
  },
  created() {
    this.buttonColor = this.$store.getters.env.get("VUE_APP_BUTTON_COLOR");
    this.LIVELAPS_HOST = this.$store.getters.env.get("VUE_APP_LIVELAPS_HOST");
    this.itemsRelationship_();
    LocalStorageService.removeItem("create_part");
    this.getLocalData();
  },
  mounted() {
    this.$emit("titlePage", "riders.addRiders");
    this.$emit("dynamicMenuItems", this.dynamicMenuItems);
  },
  updated() {
    this.itemsSelected();
  },
  computed: {
    createFormIsValid() {
      return (
        this.form.firstName &&
        this.form.lastName &&
        this.form.relationship &&
        this.form.type
      );
    },
    headers() {
      return [
        {
          text: this.$t("common.table.select"),
          value: "selected",
          sortable: false
        },
        {
          text: this.$t("riders.createRiders.table_header_ll_id"),
          value: "id",
        },
        {
          text: this.$t("riders.createRiders.table_header_first_name"),
          value: "firstName",
        },
        {
          text: this.$t("riders.createRiders.table_header_last_name"),
          value: "lastName",
        },
      ];
    },
    ...mapState({
      userStore: (state) => state.session.user,
    }), 
    bandStep1_2()  {
      if(this.step != 1) {
        return this.type == 'find' ? true : false;
      }
      return true;
    },
    itemsRelationshipOptions(){
      return this.itemsRelationship.map((el) => {
        return {
          text: this.$t(`relationship.${el.toLowerCase()}`),
          id: el
        }
      }).sort((a, b) => a.text.localeCompare(b.text));
    }
  },
  methods: {
    async getLocalData() {
      let dataLocal = LocalStorageService.getItem("create_part");
      if (dataLocal != null) {
        this.step = dataLocal.step;
        await RelationshipService.relationshipFinder(
          "idSpectator",
          dataLocal.idUser
        ).then((response) => {
          if (response.data.success == 1) {
            for (var i = 0; i < response.data.message.length; i++) {
              response.data.message[i].image =
                response.data.message[i].image != null &&
                response.data.message[i].image.length > 0
                  ? this.$store.getters.env.get("VUE_APP_ROOT") +
                    "/" +
                    response.data.message[i].image
                  : require("@/assets/images/orgPlaceholder.jpg.png");
                  this.items.push({...response.data.message[i], selected: true});
                  this.selected.push(response.data.message[i]);
            }
          } else {
            this.items = [];
          }
        });
      }
    },
    async itemsRelationship_() {
      await RelationshipService.showRelationshipValues().then((response) => {
        if (response.data.success == 1) {
          this.itemsRelationship = response.data.message;
        }
      });

      await RelationshipService.getUserRoles().then((response) => {
        if (response.data.success == 1) {
          this.userRolesItems = response.data.message;
          this.userRolesItems.find((x) => {
            if (x.userRoleCode === "Spectator") {
              this.userRoleId = x.id;
            }
          });
        }
      });

      AuthService.getUserCurrent().then((response) => {
        if (response.data.success == 1) {
          this.user = response.data.message;
        }
      });
    },
    async ImgError() {
      this.failed_image = false;
    },
    itemsSelected() {
      if (this.selected.length > 0) {
        this.spectatorSelected = true;
      } else {
        this.spectatorSelected = false;
      }
    },
    searchByEmail() {
      if (!this.$refs.formEmail.validate()) {
        return;
      }

      if (this.email == this.userStore.email) {
        this.items = [];
        this.showSnackBar(this.$t("common.cannot_add_yourself"), "error");
        return;
      }
      this.loadingEmail = true;
      RelationshipService.relationshipFinder(
        "emailAddressSpectator",
        this.email
      )
        .then((response) => {
          this.loadingEmail = false;
          if (response.data.success == 1) {
            for (var i = 0; i < response.data.message.length; i++) {
              response.data.message[i].image =
                response.data.message[i].image != null &&
                response.data.message[i].image.length > 0
                  ? this.$store.getters.env.get("VUE_APP_ROOT") +
                    "/" +
                    response.data.message[i].image
                  : require("@/assets/images/orgPlaceholder.jpg.png");
            }
            this.items = response.data.message.filter((el) => {
              return el.id != this.userStore.id;
            }).map((el) => {
              return {
                ...el,
                selected: false
              };
            });
          } else {
            this.items = [];
          }
        })
        .catch(() => {
          this.loadingEmail = false;
        });
    },
    searchByLLId() {
      if (!this.$refs.formLLId.validate()) {
        return;
      }

      if (this.LLId == this.userStore.id) {
        this.items = [];
        this.showSnackBar(this.$t("common.cannot_add_yourself"), "error");
        return;
      }
      this.loadingId = true;
      RelationshipService.relationshipFinder("idSpectator", this.LLId)
        .then((response) => {
          this.loadingId = false;
          if (response.data.success == 1) {
            for (var i = 0; i < response.data.message.length; i++) {
              response.data.message[i].image =
                response.data.message[i].image != null &&
                response.data.message[i].image.length > 0
                  ? this.$store.getters.env.get("VUE_APP_ROOT") +
                    "/" +
                    response.data.message[i].image
                  : require("@/assets/images/orgPlaceholder.jpg.png");
            }
            this.items = response.data.message.filter((el) => {
              return el.id != this.userStore.id;
            }).map((el) => {
              return {
                ...el,
                selected: false
              };
            });
          } else {
            this.items = [];
          }
        })
        .catch(() => {
          this.loadingId = false;
        });
    },
    yesCreated() {
      switch (this.step) {
        case 1:
          //this.getLocalData();
          this.step = 1.2;
          this.type = 'find';
          break;
        case 1.1:
          this.getLocalData();
          this.step = 2;
          break;
        case 1.2:
          this.step = 2;
          break;
      }
    },
    noCreated() {
      switch (this.step) {
        case 1.1:
          this.step = 1;
          this.cleanData();
          break;
        case 2:
          this.step = 1;
          break;
        case 1:
          this.step = 1.1;
          this.type = 'create';
          break;
        case 1.2:
          this.step = 1;
          break;
      }
    },
    cleanData() {
      this.selected = [];
      this.email = null;
      this.LLId = null;
      this.spectatorSelected = false;
      this.items = [];
    },
    cancel() {
      this.step = 1;
      this.cleanData();
    },
    async addSpectator() {
      if (!this.$refs.formAddSpectator.validate()) {
        return;
      }

      let data = {};
      let id_add = [];
      for (var i = 0; i < this.selected.length; i++) {
        data.relId = this.selected[i].id;
        data.relType = this.select1[this.selected[i].id];
        data.userRolesId = this.userRoleId; //Role Spectator
        id_add.push(this.selected[i].id);
        await RelationshipService.relationshipCreator(data);
      }
      const backWaiver = LocalStorageService.getItem("create_waiver_desc");
      LocalStorageService.removeItem("create_waiver_desc");
      const linkBack = LocalStorageService.getItem("link_back_spect");
      LocalStorageService.removeItem("link_back_spect");
      if (linkBack == "RegisterEventLegacy") {
        this.$router.push({ name: "RegisterEventLegacy" });
        return;
      } else if (backWaiver && backWaiver != "" && backWaiver == "Spectator") {
        this.$router.push({ name: "EventWaiverCreate" });
        return;
      } else {
        this.$router.push({
          path: "Spectators",
        });
      }
    },
    createAccount() {
      this.bandCreateAccount = true;
    },
    selectRow(item,type = "check") {
      
      if(type == "check") {
        let _item1 = this.items.indexOf(item);
        if(_item1 > -1) {
            if(this.items[_item1].selected) {
              this.items[_item1].selected = true;
            } else  if(!this.items[_item1].selected) {
              this.items[_item1].selected = false;
            }
        }
        let _item = this.selected.find((el) => {
          return el.id == item.id;
        });
        if (_item) {
          if(_item1 > -1 && !this.items[_item1].selected) {
            this.selected = this.selected.filter((el) => {
              return el.id != item.id;
            });
          }
        } else {
          if(_item1 > -1 && this.items[_item1].selected) {
            this.selected.push(item);
          }
        }
      } else {
        this.items.forEach((el) => {
          if(el.id == item.id) {
            el.selected = false;
          }
        });
        this.selected = this.selected.filter((el) => {
          return el.id != item.id;
        });
      }
      
    },
    showSnackBar(msg, color) {
      this.snackbar = true;
      this.msg_snackbar = msg;
      this.color_snackbar = color;
      setTimeout(() => (this.snackbar = false), 3000);
    },
    previusStep() {
      this.step = 1;
      this.bandCreateAccount = false;
    },
    goBack() {
      const previusLink = LocalStorageService.getItem("previus_link");
      this.$router.push({ name: previusLink.name, query: previusLink.query, params: previusLink.params });
    }
  },
  beforeDestroy() {
    LocalStorageService.removeItem("link_back_spect");
  },
};
</script>

<style>
.btn_bg {
  height: 50px !important;
  min-width: 250px !important;
  color: #fff !important;
}
.btn_back {
  height: 50px !important;
  color: #fff !important;
}
.lbl_search .v-icon {
  margin-bottom: 5px;
  font-size: 18px;
}
.dt_rider .v-data-footer {
  height: 38px;
}
.dt_rider .v-data-footer__select .v-select {
  margin: 0px 0px 0px 34px;
}
.dt_rider .v-data-table-header {
  background: #ccc;
}
.st_items .v-stepper__content {
  padding-top: 12px;
}
@media (max-width: 599px) {
  .btn_bg,
  .btn_xs_rsp {
    max-width: 100%;
    min-width: auto !important;
    height: auto !important;
  }
  .btn_bg span,
  .btn_xs_rsp span {
    white-space: normal;
    max-width: 100%;
  }
  .lbl_search .v-text-field__details,
  .lbl_search .v-text-field__details .v-messages {
    min-height: 0px;
    margin-bottom: 0px !important;
  }
  .btn_bg {
    min-height: 50px;
  }
  .btn_xs_rsp {
    min-height: 36px;
  }
}
</style>
